import React, { useEffect, useState } from 'react';
import { Toast, ToastGroup } from '@flowio/react-toast';
import { Card, CardHeader, CardContent } from '@flowio/react-card';
import BasicInformationForm from './basic-information-form';
import * as styles from './profile.styles';

type Props = {
  user: io.flow.v0.models.User;
  onBasicInformationUpdate?: (user: io.flow.v0.models.UserPutForm) => void;
  updateBasicInformationSuccess?: boolean;
};

const AccountProfile: React.FC<Props> = ({
  updateBasicInformationSuccess,
  user,
  onBasicInformationUpdate,
}) => {
  const [basicInfoFormDisabled, setBasicInfoFormDisabled] = useState(true);
  const [toastContent, setToastContent] = useState([] as string[]);

  useEffect(() => {
    if (updateBasicInformationSuccess) {
      setBasicInfoFormDisabled(true);
      setToastContent(['Successfully updated basic information!']);
    }
  }, [updateBasicInformationSuccess]);

  const handleBasicInfoModification = () => {
    setBasicInfoFormDisabled(false);
  };

  const handleBasicInformationSnackbarClose = () => {
    setToastContent([]);
  };

  return (
    <section className={styles.accountProfile}>
      <Card id="basic-information" className="basic-information">
        <CardHeader dividing>
          Basic Information
        </CardHeader>
        <CardContent>
          <BasicInformationForm
            disabled={basicInfoFormDisabled}
            user={user}
            onModification={handleBasicInfoModification}
            onSubmit={onBasicInformationUpdate}
          />
        </CardContent>
      </Card>
      <ToastGroup>
        {toastContent.map((content) => (
          <Toast
            onClose={handleBasicInformationSnackbarClose}
            className="account-toast"
            key="toasty"
            eventKey="toasty"
            intent="positive"
            icon="CheckCircle"
            content={content}
          />
        ))}
      </ToastGroup>

    </section>
  );
};

AccountProfile.displayName = 'AccountProfile';

export default AccountProfile;
